export default {
  title: "light",
  colors: {
    primary: "#DCDCDC",
    secondary: "#FFFFFF",
    tertiary: "#E5E5E5",
    white: "#000",
    black: "#FFF",
    gray: "#BFBFBF",
    success: "#03BB85",
    info: "#3B5998",
    warning: "#FF6961",
  },
};
